"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from "react";
import classNames from "classnames";
import { BoxList, } from "../box-list/box-list";
import { IconButton } from "../../buttons";
import styles from "./box-scroller.module.css";
import ChevronIcon from "@travel/shared/assets/icons/icon-chevron.svg";
export var BoxScroller = forwardRef(function BoxScroller(_a, ref) {
    var _b;
    var id = _a.id, _c = _a.initialIndex, initialIndex = _c === void 0 ? 0 : _c, className = _a.className, scrollerClassName = _a.scrollerClassName, controlClassName = _a.controlClassName, prevControlClassName = _a.prevControlClassName, nextControlClassName = _a.nextControlClassName, shadowClassName = _a.shadowClassName, prevShadowClassName = _a.prevShadowClassName, nextShadowClassName = _a.nextShadowClassName, boxClassName = _a.boxClassName, _d = _a.direction, direction = _d === void 0 ? "horizontal" : _d, _e = _a.items, items = _e === void 0 ? [] : _e, _f = _a.index, index = _f === void 0 ? 0 : _f, _g = _a.fills, fills = _g === void 0 ? false : _g, _h = _a.fillsMobile, fillsMobile = _h === void 0 ? false : _h, _j = _a.hideControls, hideControls = _j === void 0 ? false : _j, _k = _a.hideControlsMobile, hideControlsMobile = _k === void 0 ? false : _k, _l = _a.hideScrollbars, hideScrollbars = _l === void 0 ? true : _l, _m = _a.hideShadowsMobile, hideShadowsMobile = _m === void 0 ? hideControlsMobile : _m, _o = _a.showControlShadow, showControlShadow = _o === void 0 ? false : _o, _p = _a.showControlsOnHover, showControlsOnHover = _p === void 0 ? false : _p, _q = _a.controlsSize, controlsSize = _q === void 0 ? "lg" : _q, onChange = _a.onChange, _r = _a.snapOnInit, snapOnInit = _r === void 0 ? true : _r, style = _a.style, rest = __rest(_a, ["id", "initialIndex", "className", "scrollerClassName", "controlClassName", "prevControlClassName", "nextControlClassName", "shadowClassName", "prevShadowClassName", "nextShadowClassName", "boxClassName", "direction", "items", "index", "fills", "fillsMobile", "hideControls", "hideControlsMobile", "hideScrollbars", "hideShadowsMobile", "showControlShadow", "showControlsOnHover", "controlsSize", "onChange", "snapOnInit", "style"]);
    var _s = __read(useState([0, null]), 2), _t = __read(_s[0], 2), minIndex = _t[0], maxIndex = _t[1], setIndex = _s[1];
    var scrollerRef = useRef(null);
    var _u = __read(useState(false), 2), isReady = _u[0], setIsReady = _u[1];
    var isTransitioningRef = useRef(false);
    var indexRef = useRef([index, index]);
    var visibleRef = useRef([]);
    var fullyVisibleRef = useRef([]);
    var prevRef = useRef(null);
    var nextRef = useRef(null);
    var shadowPrevRef = useRef(null);
    var shadowNextRef = useRef(null);
    var controlsRef = useRef(null);
    var hasSetInitialIndex = useRef(false);
    var boxListRef = useRef(null);
    var boxListStateRef = useRef();
    var elRef = useRef(null);
    useImperativeHandle(ref, function () {
        return {
            el: elRef.current,
            goTo: goTo,
        };
    }, [elRef === null || elRef === void 0 ? void 0 : elRef.current]);
    useEffect(function () {
        if (!hasSetInitialIndex.current)
            return;
        goTo(index);
    }, [index]);
    useEffect(function () {
        if (!hasSetInitialIndex.current) {
            setTimeout(function () {
                hasSetInitialIndex.current = true;
            }, 10);
            goTo(initialIndex, snapOnInit);
        }
        setTimeout(function () {
            setIsReady(true);
        }, 2000);
    }, []);
    return (_jsxs("div", { className: classNames(styles["container"], className, (_b = {},
            _b[styles[direction]] = true,
            _b[styles["hide-scrollbars"]] = hideScrollbars,
            _b[styles["hide-controls-mobile"]] = hideControlsMobile,
            _b[styles["has-controls"]] = showControlsOnHover,
            _b[styles["fills"]] = fills,
            _b[styles["fills-mobile"]] = fillsMobile,
            _b[styles["has-control-shadows"]] = showControlShadow,
            _b[styles["hide-shadows-mobile"]] = hideShadowsMobile,
            _b[styles["ready"]] = isReady,
            _b)), style: style, ref: elRef, children: [_jsx(BoxList, __assign({}, rest, { direction: direction, className: classNames(styles["scroller"], scrollerClassName), boxClassName: classNames(styles["box"], boxClassName), windowScroller: false, onChange: handleBoxListChange, ref: boxListRef, children: items })), !hideControls && (_jsxs("div", { className: styles["controls"], ref: controlsRef, children: [_jsx("div", { className: classNames(styles["shadow"], styles["left"], shadowClassName, prevShadowClassName), ref: shadowPrevRef }), _jsx("div", { className: classNames(styles["shadow"], styles["right"], shadowClassName, nextShadowClassName), ref: shadowNextRef }), _jsx(IconButton, { type: "button", className: classNames(styles["control"], styles["prev"], controlClassName, prevControlClassName, styles[controlsSize]), icon: _jsx(ChevronIcon, { className: styles["icon"], height: 16 }), theme: "dark", centered: true, onClick: function (event) {
                            var _a;
                            event.preventDefault();
                            event.stopPropagation();
                            (_a = boxListRef.current) === null || _a === void 0 ? void 0 : _a.scrollToPrev();
                        }, ref: prevRef }), _jsx(IconButton, { type: "button", className: classNames(styles["control"], styles["next"], controlClassName, nextControlClassName, styles[controlsSize]), theme: "dark", icon: _jsx(ChevronIcon, { className: styles["icon"], height: 16 }), centered: true, onClick: function (event) {
                            var _a;
                            event.preventDefault();
                            event.stopPropagation();
                            (_a = boxListRef.current) === null || _a === void 0 ? void 0 : _a.scrollToNext();
                        }, ref: nextRef })] }))] }));
    function handleBoxListChange(state) {
        var _a, _b;
        boxListStateRef.current = state;
        toggleControl("prev", (((_a = state.minVisible) === null || _a === void 0 ? void 0 : _a.index) || 0) > 0);
        toggleControl("next", (((_b = state.maxVisible) === null || _b === void 0 ? void 0 : _b.index) || 0) < items.length - 1);
        onChange === null || onChange === void 0 ? void 0 : onChange(state);
    }
    function goTo(index, instant, end) {
        var _a;
        if (instant === void 0) { instant = false; }
        if (end === void 0) { end = false; }
        (_a = boxListRef.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex(index, instant, "center");
    }
    function toggleControl(direction, isVisible) {
        var control = direction === "prev" ? prevRef.current : nextRef.current;
        var shadow = direction === "prev" ? shadowPrevRef.current : shadowNextRef.current;
        var opacity = control === null || control === void 0 ? void 0 : control.style.opacity;
        if (shadow) {
            shadow.style.opacity = isVisible ? "1" : "0";
        }
        if (!control ||
            (isVisible && opacity === "1") ||
            (!isVisible && opacity === "0"))
            return;
        control.style.opacity = isVisible ? "1" : "0";
    }
});
export function BoxScrollerBox(_a) {
    var className = _a.className, children = _a.children;
    return _jsx("div", { className: classNames(styles["box"], className), children: children });
}
